import type { AppRouteRecordRaw } from "shared/types";

/** Webmaster NPS data page, spliced into the webmaster route children. */
export const npsDataRouteFragment: AppRouteRecordRaw = {
  path: "nps-data",
  name: "NpsData",
  component: () => import("nps/pages/NpsDataPage.vue"),
  meta: {
    title: "NPS",
    roleRequired: ["webmaster"],
    isMenuItem: true,
    menuSection: "manage",
  },
};
